import script from "./TradePassportExperiencesOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportExperiencesOverview.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportExperiencesOverview.vue?vue&type=style&index=0&id=50f6a0f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f6a0f7"]])

export default __exports__